module.exports = __webpack_public_path__ + "static/media/order-now-bg.4f15caa2.png";